import ListItem from "@mui/material/ListItem";
import { Link } from "react-router-dom";

function MarkerCard({
                        market,
                        isSelected,
                        onSelect,
                        MARKET_BASE_URL_API,
                        defaultMarketImage
                    }) {


    const imgUrl = market?.pictures?.[0]?.url
        ? MARKET_BASE_URL_API + market.pictures[0].url
        : defaultMarketImage;

    // محتوا کوتاه‌شده برای یک خط
    const shortContent =
        (market.content || 'بدون توضیح').length > 60
            ? market.content.slice(0, 60) + '…'
            : market.content || 'بدون توضیح';

    const listItemStyle = {
        flex: 1,
        fontSize: 13,
        borderRadius: 20,
        padding: '6px 8px',
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        whiteSpace: 'nowrap',
        background: '#f8f9fa',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        margin: 0
    };




    return (
        <div
            onClick={onSelect}
            style={{
                display: 'inline-block',
                scrollSnapAlign: 'center',
                width: 320,
                whiteSpace: 'normal',
                background: '#fff',
                borderRadius: 16,
                boxShadow: isSelected
                    ? '0 6px 20px rgba(0,0,0,0.25)'
                    : '0 4px 12px rgba(0,0,0,0.12)',
                padding: 16,
                marginInline: 8,
                cursor: 'pointer',
                textAlign: 'right',
                direction: 'rtl',
                border: isSelected ? '2px solid #ff3d71' : '2px solid transparent',
            }}
        >
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{flex: 1, minWidth: 0}}>
                    <div
                        style={{
                            fontWeight: 700,
                            fontSize: 16,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                        title={market.name}
                    >
                        {market.name}
                    </div>
                    <div
                        style={{
                            fontSize: 13,
                            color: '#555',
                            marginTop: 4,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                        title={market.content}
                    >
                        {shortContent}
                    </div>
                    <div style={{fontSize: 12, color: '#888', marginTop: 4}}>
                        فاصله: {market.distanceText ? `${market.distanceText}` : '—'}
                    </div>
                </div>
                <div
                    style={{
                        width: 56,
                        height: 56,
                        marginLeft: 12,
                        borderRadius: '50%',
                        background: '#eee',
                        backgroundImage: `url(${imgUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        border: '2px solid #eee'
                    }}
                />
            </div>

            {/* Buttons */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // ✅ Allow wrapping
                    marginTop: 16,
                    gap: 8,
                    overflow: 'hidden', // ✅ Ensure children don't overflow card
                }}
            >
                <ListItem
                    button
                    component={Link}
                    to={`/messenger/chat?chat_id=${market.chat_id || market.id}`}
                    style={listItemStyle}
                >
                    <span>💬</span><span>چت</span>
                </ListItem>

                <ListItem
                    button
                    component="a"
                    href={`tel:${market.tell || ''}`}
                    style={listItemStyle}
                >
                    <span>📞</span><span>تماس</span>
                </ListItem>

                <ListItem
                    button
                    component={Link}
                    to={`/market?id=${market.id}`}
                    style={listItemStyle}
                >
                    <span>🏪</span><span>فروشگاه</span>
                </ListItem>

                <ListItem
                    button
                    component="a"
                    href={`https://www.google.com/maps/dir/?api=1&destination=${market.lat},${market.long}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={listItemStyle}
                >
                    <span>🧭</span><span>مسیر‌یابی</span>
                </ListItem>
            </div>

        </div>
    );
}

export default MarkerCard;

